/** @jsxImportSource @emotion/react */
import React from "react";
import ReactModal from "react-modal";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { MODAL_SELECTORS } from "../modalSelectors";
import { ModalContent } from "../../../general/ModalContent/ModalContent";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ReactComponent as RegionRestrictedImage } from "../../../../img/region_restricted.svg";
import { ReactComponent as ChevronRight } from "../../../../img/chevron_right.svg";
export const RegionRestrictedModal: React.FC = props => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <>
      <ReactModal
        isOpen={modalSelector === MODAL_SELECTORS.REGION_RESTRICTED}
        className={`react-modal`}
        style={{
          content: {
            margin: "0 auto",
          },
        }}
      >
        <ModalContentContainer className={`new-skin modal-dialog modal-dialog-centered m-frame`}>
          <ModalContent backgroundColor="alt">
            <Container>
              <RegionRestrictedImageContainer>
                <RegionRestrictedImage />
              </RegionRestrictedImageContainer>
              <RegionRestrictedHeader>Region Restricted</RegionRestrictedHeader>
              <RegionRestrictedExplanation>
                We are unable to let you proceed at this time as it appears you are accessing Bebop
                from the United States.
              </RegionRestrictedExplanation>
              <RegionRestrictedTerms
                as="a"
                // @ts-expect-error Typescript does not respect the "as" prop
                href={"https://bebop.xyz/terms.pdf"}
                theme={theme}
                css={css`
                  :hover path {
                    stroke: ${theme.button.primary.text.hover};
                    border: none;
                  }
                `}
              >
                See our Terms & Conditions{" "}
                <ChevronRight
                  css={css`
                    margin-left: -4px;
                  `}
                />
              </RegionRestrictedTerms>
              <RegionRestrictedButton
                theme={theme}
                onClick={() => {
                  GlobalStore.update(s => {
                    s.modalSelector = undefined;
                  });
                }}
              >
                OK
              </RegionRestrictedButton>
            </Container>
          </ModalContent>
        </ModalContentContainer>
      </ReactModal>
    </>
  );
};

// Sub-components

const Container = styled.div(() => ({
  margin: "0.94rem",
  display: "flex",
  flexDirection: "column",
}));

const ModalContentContainer = styled.div`
  margin: auto;
  width: 450px;
`;
const RegionRestrictedImageContainer = styled.div`
  margin: 0.6rem auto 0;
`;
const RegionRestrictedHeader = styled.h2(props => ({
  textAlign: "center",
  marginTop: "1rem",
  marginBottom: "1rem",
  color: props.theme.button.primary.text.hover,
  fontFamily: props.theme.fontFamilies.Primary,
  fontWeight: props.theme.fontWeights["work-sans-0"],
  fontSize: props.theme.fontSize["7"],
}));
const RegionRestrictedExplanation = styled.div`
  text-align: center;
  padding: 0rem 3.8125rem;
`;
const RegionRestrictedTerms = styled.div(props => ({
  marginTop: "0.5rem",
  textAlign: "center",
  color: props.theme.button.primary.surface.active,
  padding: "0rem 1.8125rem",
  fontFamily: props.theme.fontFamilies.Primary,
  fontSize: props.theme.fontSize["5"],
  fontStyle: "normal",
  fontWeight: props.theme.fontWeights["work-sans-2"],
  lineHeight: "130%",
}));
const RegionRestrictedButton = styled.button(props => ({
  height: "3.5rem",
  backgroundColor: props.theme.button.primary.surface.default,
  borderRadius: "0.875rem",
  color: props.theme.button.primary.text.hover,
  border: "none",
  marginTop: "1rem",
}));
